module.exports = __webpack_public_path__ + "5528a872b054b09f8aadc89286e4a08b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00000XHC.png
// module id = 1644
// module chunks = 0